import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import API from '../../../create/api';
import { Pagination } from '@mui/material';
import moment from 'moment';
const MyTable = () => {
  const [data, setData]: any = useState([]);
  const [page, setPage]: [number, any] = useState(1);

  useEffect(() => {
    const fetchData = async () => {
      const _limit = 10;
      const start = (page - 1) * _limit;
      const userLogs: any = await API.getAll(
        `${process.env.REACT_APP_API_SERVER}/user-logs?_start=${start}&_limit=${_limit}&_sort=created_at:DESC`,
      );
      setData(userLogs);
    };
    fetchData();
  }, [page]);

  const handlePageChange = (event: any, value: number) => {
    setPage(value);
  };

  return (
    <div>
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold">User Log</h1>
      </div>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell>User Id</TableCell>
            <TableCell>Log</TableCell>
            <TableCell>Time</TableCell>
          </TableRow>
          {data.map((item: { user_id: number; log: string; created_at: string }, index: number) => (
            <TableRow key={index}>
              <TableCell>{item.user_id}</TableCell>
              <TableCell>{item.log}</TableCell>
              <TableCell>
                {moment(moment()).diff(item.created_at, 'days') > 1
                  ? moment(item.created_at).format('YYYY-MM-DD HH:mm:ss')
                  : moment(item.created_at).fromNow()}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Pagination page={page} count={10} onChange={handlePageChange} />
    </div>
  );
};

export default MyTable;
